import { render, staticRenderFns } from "./campaignListItem.vue?vue&type=template&id=57a32705&scoped=true"
import script from "./campaignListItem.vue?vue&type=script&lang=js"
export * from "./campaignListItem.vue?vue&type=script&lang=js"
import style0 from "./campaignListItem.vue?vue&type=style&index=0&id=57a32705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a32705",
  null
  
)

export default component.exports